// Bearer-token storage for the SPA. The API is cookie-free / JSON-only,
// so the SPA owns its own access + refresh token lifecycle.
//
// localStorage is used so tokens survive page reload. /login/complete
// writes them; halFetch reads on every request; logout clears them.
// The typeof guard exists so this module can be imported in code paths
// that may run during SSR or in tests without a DOM.

const ACCESS_KEY = "mayfirm.access_token";
const REFRESH_KEY = "mayfirm.refresh_token";

export function getAccessToken(): string | null {
  if (typeof localStorage === "undefined") return null;
  return localStorage.getItem(ACCESS_KEY);
}

export function getRefreshToken(): string | null {
  if (typeof localStorage === "undefined") return null;
  return localStorage.getItem(REFRESH_KEY);
}

export function setTokens(access: string, refresh: string): void {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(ACCESS_KEY, access);
  localStorage.setItem(REFRESH_KEY, refresh);
}

export function clearTokens(): void {
  if (typeof localStorage === "undefined") return;
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
}
